module.exports = __webpack_public_path__ + "img/jameazad.99281b2.png";